import { AlertCircle, Loader2 } from 'lucide-react';

export function OtpStep({
  email, otp, onOtpChange, onSubmit, onResend, onBack,
  loading, error, resendCd,
  trustDevice, onTrustDeviceChange,
}) {
  return (
    <form onSubmit={onSubmit} className="w-full">
      <div className="lm-kicker">Check your inbox</div>
      <h2 className="lm-h2">Enter your code</h2>
      <p className="lm-body">
        We sent a six-digit code to <strong style={{ fontWeight: 600, color: '#201f1d' }}>{email}</strong>.
      </p>

      <div className="lm-field">
        <label htmlFor="login-otp">Sign-in code</label>
        <input
          id="login-otp"
          type="text"
          inputMode="numeric"
          maxLength={6}
          className="lm-input"
          style={{ fontSize: 22, letterSpacing: '0.5em', textAlign: 'center', minHeight: 48 }}
          value={otp}
          onChange={onOtpChange}
          placeholder="••••••"
          autoComplete="one-time-code"
          autoFocus
          data-testid="otp-input"
        />
      </div>

      {error && (
        <p className="lm-error" data-testid="error-msg">
          <AlertCircle className="w-4 h-4 shrink-0" />{error}
        </p>
      )}

      <label className="lm-check">
        <input
          type="checkbox"
          checked={!!trustDevice}
          onChange={(e) => onTrustDeviceChange?.(e.target.checked)}
          data-testid="trust-device-checkbox"
        />
        Trust this device for 30 days (skip the code next time)
      </label>

      <button type="submit" className="lm-btn" disabled={loading || otp.length < 6} data-testid="otp-submit">
        {loading ? (<><Loader2 className="w-4 h-4 animate-spin" />Verifying…</>) : 'Sign in'}
      </button>

      <div className="lm-divider" />
      <p className="lm-foot">
        Nothing arrived?{' '}
        <button type="button" className="lm-link" onClick={onResend} disabled={resendCd > 0} data-testid="resend-btn">
          {resendCd > 0 ? `Send it again in ${resendCd}s` : 'Send it again'}
        </button>
        {' '}&nbsp;·&nbsp;{' '}
        <button type="button" className="lm-link" onClick={onBack} data-testid="back-btn">
          Use a different email
        </button>
      </p>
    </form>
  );
}
